import { format, isDate, isValid } from "date-fns";
// import { toZonedTime } from "date-fns-tz";
import { TimeframeTypeEnum } from "../enums/TimeframeTypeEnum";

const DATE_FORMAT_STRING = "MM/dd/yyyy";
const DATE_TIME_FORMAT_STRING = "MM/dd/yyyy h:mm:ss a";
const TIME_FORMAT_STRING = "h:mm:ss a";
const HOUR_MIN_FORMAT_STRING = 'h:mm a';

export { DATE_FORMAT_STRING, DATE_TIME_FORMAT_STRING, TIME_FORMAT_STRING, HOUR_MIN_FORMAT_STRING };


export function getTimeframeTimeDisplayText(timeframe: TimeframeTypeEnum, dateValue: string | Date): string {

    let returnDateString: string = "";
    let convertedDateTime: Date | null = getTimeframeDateOrNull(timeframe, dateValue);

    if (convertedDateTime) {
        //returnDateString = convertedDateTime.format(getTimeframeFormat(timeframe));
        returnDateString = format(convertedDateTime, getTimeframeFormat(timeframe));
    }

    return returnDateString;
}

// Creates a date object at midnight.
export function getDailyDate(dateObject: Date): Date {
    return new Date(dateObject.getFullYear(), dateObject.getMonth(), dateObject.getDate(), 0, 0, 0, 0);
}

// Creates a date object at midnight and does not perform the normal time zone functions when parsing a string.
export function getDailyDateOrNull(dateValue: any): Date | null {
    var date: Date | null = getDateOrNull(dateValue);
    // return date ? getDailyDate(toZonedTime(date, "+00:00")) : null;
    return date
        ? new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0)
        : null;
}

export function getTimeframeDateOrNull(timeframe: TimeframeTypeEnum, dateValue: string | Date): Date | null {

    var returnDate: Date | null = null;

    if (timeframe) {

        switch (timeframe) {
            case TimeframeTypeEnum.Hourly:
                // This must be a natural Hourly value. Natural hourly values will not be converted to the user’s time zone.
                returnDate = getDateOrNull(dateValue);;
                break;

            case TimeframeTypeEnum.Daily:
            case TimeframeTypeEnum.Monthly:
            case TimeframeTypeEnum.Yearly:
                returnDate = getDailyDateOrNull(dateValue);
                break;

            default:
                // Hourly groupings of spot values will not have a timeframe set. Hourly groupings of spot tag values will 
                //  show timestamps with dates and times and they will be converted to the user’s time zone.
                //  This is different than TATs that are naturally hourly values. See Enums.TimeframeTypeEnum.Hourly above.
                returnDate = getDateOrNull(dateValue);
        }
    }
    else {
        returnDate = getDateOrNull(dateValue);
    }

    return returnDate;
}

export function shouldDisplayTime(timeframe: TimeframeTypeEnum): boolean {
    //User Story 53044: Research - 2025 Q2 - Review GAS report
    let shouldDisplayTime: boolean;// = true;

    switch (timeframe) {
        case TimeframeTypeEnum.Daily:
        case TimeframeTypeEnum.Monthly:
        case TimeframeTypeEnum.Yearly:
            shouldDisplayTime = false;
            break;

        default:
            shouldDisplayTime = true;
    }

    return shouldDisplayTime;
}

export function getTimeframeFormat(timeframe: TimeframeTypeEnum): string {

    let datetimeFormat: string;

    switch (timeframe) {
        case TimeframeTypeEnum.Daily:
        case TimeframeTypeEnum.Monthly:
        case TimeframeTypeEnum.Yearly:
            //datetimeFormat = "L";
            datetimeFormat = DATE_FORMAT_STRING;
            break;

        default:
            //datetimeFormat = "L LTS";
            datetimeFormat = DATE_TIME_FORMAT_STRING;
    }

    return datetimeFormat;
}

// Creates a date object and optionally does or does not perform the normal time zone functions when parsing a string.
export function getDateOrNull(dateValue: string | Date): Date | null {

    var returnDate: Date | null = null;

    if (dateValue) {
        if (typeof dateValue === "string" && dateValue.length > 0) {

            var value: Date = new Date(dateValue);

            if (isValid(value)) {
                returnDate = value;
            }
        }
        else if (isDate(dateValue)) {
            returnDate = dateValue as Date;
        }
    }

    return returnDate;
}

// This only works for Highcharts if the global useUTC property is set to true and Highcharts does not try to convert the date to local time. We do the conversion
//  and let Highcharts work as if it is UTC when it is really local time.
export function getHighchartsLocalDateMilliseconds(displayTimeframe: TimeframeTypeEnum, dateValue: string | Date): number {

    let date = getTimeframeDateOrNull(displayTimeframe, dateValue) as Date;

    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(),
            date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}

